<template>
  <div class="modal-box" v-if="showModal" @click.self="isShow">
    <div class="content-box" :style="style" ref="box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    x: {
      type: String,
      required: true
    },
    y: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      style: {
        top: 0,
        left: 0
      }
    }
  },
  watch: {
    show (value) {
      this.showModal = value
    },
    x (value) {
      this.style.left = value
    },
    y (value) {
      this.style.top = value
    }
  },
  created () {

  },
  updated () {
    const box = this.$refs.box
    if (box) {
      const w = box.offsetWidth
      const h = box.offsetHeight
      if (w + parseInt(this.x) > window.innerWidth) {
        this.style.left = parseInt(this.x) - w + 'px'
      }
      // console.log(h, this.y, window.innerHeight)
      if (h + parseInt(this.y) > window.innerHeight) {
        this.style.top = parseInt(this.y) - h + 'px'
      }
    }
  },
  methods: {
    isShow () {
      this.showModal = false
      this.$emit('showChange', this.showModal)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: auto;
  .content-box {
    position: absolute;
  }
}
</style>
